import useI18n from '@app/shared/vue/composables/use-I18n'
import { segmentVisibilities } from '../types/index'
import type { SegmentVisibilityData } from '../types/index'

export default function useSegmentVisibilities(): SegmentVisibilityData {
  const I18n = useI18n()

  const visibilitiesData = {
    [segmentVisibilities.PRIVATE_VISIBLE]: {
      icon: 'fa-user',
      name: I18n.t('companies_overview.segments_new.visibilities.private.name'),
      desc: I18n.t('companies_overview.segments_new.visibilities.private.desc'),
      tooltip: I18n.t(
        'companies_overview.segments_new.visibilities.private.tooltip'
      ),
    },
    [segmentVisibilities.ADMIN_VISIBLE]: {
      icon: 'fa-screwdriver-wrench',
      name: I18n.t('companies_overview.segments_new.visibilities.admin.name'),
      desc: I18n.t('companies_overview.segments_new.visibilities.admin.desc'),
      tooltip: I18n.t(
        'companies_overview.segments_new.visibilities.admin.tooltip'
      ),
    },
    [segmentVisibilities.FIRM_VISIBLE]: {
      icon: 'fa-building',
      name: I18n.t('companies_overview.segments_new.visibilities.firm.name'),
      desc: I18n.t('companies_overview.segments_new.visibilities.firm.desc'),
      tooltip: I18n.t(
        'companies_overview.segments_new.visibilities.firm.tooltip'
      ),
    },
  }

  return visibilitiesData
}
